// extracted by mini-css-extract-plugin
export default {"wrapper":"layout-module--wrapper--XsmH9","tbcom":"layout-module--tbcom--nXLzk"};